import commonModule from "./cn/common";
import userModule from "./cn/user";
import loginModule from "./cn/login";
import registerModule from "./cn/register";
import questionModule from "./cn/question";
import statusModule from "./cn/status";
import codeModule from "./cn/errorCode";
import { storeModule, evaluationModule } from "./cn/store";
import { orderModule } from "./cn/order";
import { homeModule, searchModule } from "./cn/home";
import { otherModule } from "./cn/other";
import { goodsCouponModule } from "@/i18n/config/cn/goodsCoupon";
const zh = {
    commonBox: commonModule,
    loginBox: loginModule,
    registerBox: registerModule,
    questionBox: questionModule,
    //店铺详情
    storeDetail: storeModule,
    //评价部分
    evaluationBox: evaluationModule,
    orderModule: orderModule,
    //首页
    home: homeModule,
    searchModule: searchModule,
    userModule: userModule,
    //状态
    status: statusModule,
    //错误码
    errorCode: codeModule,
    //其它
    otherModule: otherModule,
    goodsCouponModule: goodsCouponModule,
};
export default zh;
